import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const DocumentConfig = {
  generateType: [
    { id: 1, title: "PDF", value: "pdf" },
    { id: 2, title: "Excel", value: "excel" },
  ],
  blackAndWhite: [
    { id: 1, title: "Color", value: "color" },
    { id: 2, title: "Black & White", value: "black & White" },
  ],
  orientation: [
    { id: 1, title: "Portrait", value: "portrait" },
    { id: 2, title: "Landscape", value: "landscape" },
  ],
};

const ExportConfig = ({ exportConfig, onChange }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleChange = (field, value) => {
    onChange({
      ...exportConfig,
      [field]: value,
    });
  };

  return (
    <div className="bg-white shadow-md rounded-xl border border-gray-200 w-full transition-all duration-300 overflow-hidden">
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between gap-2 p-5 hover:bg-gray-50 transition-colors cursor-pointer"
      >
        <div className="flex items-center gap-2">
          <div className="p-2 bg-green-50 rounded-lg">
            <svg
              className="w-5 h-5 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>
          <h3 className="text-base font-semibold text-gray-800">Export Configuration</h3>
        </div>
        <ChevronDown
          className={`w-5 h-5 text-gray-600 transition-transform duration-300 ${
            isExpanded ? "rotate-180" : ""
          }`}
        />
      </button>
      
      <div
        className={`space-y-4 px-5 transition-all duration-100 ease-in-out ${
          isExpanded ? "max-h-[1000px] opacity-100 pb-5" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
          <label className="text-sm text-gray-700 font-medium min-w-[120px]">
            Generate Type
          </label>
          <select
            className="flex-1 border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none transition-all bg-white hover:border-gray-400"
            value={exportConfig?.generateType || ""}
            onChange={(e) => handleChange("generateType", e.target.value)}
          >
            <option value="">Select type</option>
            {DocumentConfig.generateType.map((option) => (
              <option key={option.id} value={option.value}>
                {option.title}
              </option>
            ))}
          </select>
        </div>

       {exportConfig?.generateType !== "excel" && <> <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
          <label className="text-sm text-gray-700 font-medium min-w-[120px]">
            Color Mode
          </label>
          <select
            className="flex-1 border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none transition-all bg-white hover:border-gray-400"
            value={
              exportConfig?.blackAndWhite === false || exportConfig?.blackAndWhite === "color" || !exportConfig?.blackAndWhite
                ? "color"
                : "black & White"
            }
            onChange={(e) => {
              const value = e.target.value === "black & White";
              handleChange("blackAndWhite", value);
            }}
          >
            {DocumentConfig.blackAndWhite.map((option) => (
              <option key={option.id} value={option.value}>
                {option.title}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
          <label className="text-sm text-gray-700 font-medium min-w-[120px]">
            Orientation
          </label>
          <select
            className="flex-1 border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none transition-all bg-white hover:border-gray-400"
            value={exportConfig?.orientation || "portrait"}
            onChange={(e) => handleChange("orientation", e.target.value)}
          >
            {DocumentConfig.orientation.map((option) => (
              <option key={option.id} value={option.value}>
                {option.title}
              </option>
            ))}
          </select>
          </div>
        </>}
      </div>
    </div>
  );
};

export default ExportConfig;

